import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './Services/auth.service';

;

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    {
      if (this.authService.isAuthenticated()) {
        const roles = route.data['roles'] as Array<string>;
        if (roles && roles.length > 0) {
          const userRoles       = this.authService.getRoles();
          //const paystatus       = this.authService.getPaymentStatus();
          const hasRequiredRole   = roles.some(role => userRoles.includes(role));
          let statusEmail         = this.authService.getEmailStatus();
          //let statusLock        = this.authService.getLock();
          //let emailSetup        = this.authService.getEmailSetup();
          // if (hasRequiredRole && (statusEmail == "false")) {
          //   return this.router.navigate(['/confirmEmail']);
          // }
          // else if (hasRequiredRole && (statusEmail == "true") && paystatus == "true" && emailSetup=="Yes") {
          //   return this.router.navigate(['/EmailDevelery']);
          // }
          // else if (hasRequiredRole && (statusEmail == "true") && paystatus == "true" && statusLock == "true") {
          //   return this.router.navigate(['/Locked']);
          // }
          if (!hasRequiredRole) {
            this.router.navigate(['/unauthorized']);
            return false;
          }
        }
        return true;
      }
      this.router.navigate(['/login']);
      return false;
    }
  }
}
